<ul class="product-social">
    <li>
        <a (cbOnSuccess)="showToaster()" [cbContent]="url" href="javascript:void(0)" ngxClipboard>
            <i class="fa fa-share-alt"></i>
        </a>
    </li>
</ul>
